/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
/* eslint-disable max-len */
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { NotificationsService } from '../services/notifications.service';
import { AngularFireDatabase } from '@angular/fire/database';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})

export class GroupService {

    endReached = false;
    groups = [];
    group;
    storage = firebase.storage();
    currentUser = this.authService.currentUser;
    unsub1;
    constructor(
        public firestore: AngularFirestore,
        public database: AngularFireDatabase,
        public authService: AuthService,
        public route: ActivatedRoute,
        public toastController: ToastController,
        public navController: NavController,
        public modalController: ModalController,
        public notificationsService: NotificationsService
    ) {
        this.unsub1 = this.authService.currentAccount.subscribe(async (user) => {
            if (user) {
                this.currentUser = user;
            }
        });
    }


    async getUserGroups(id) {
        return new Promise(async (resolve, reject) => {
            const data = [];
            const group = this.firestore.collection('groups', ref => ref.where('admins', 'array-contains', id));
            const documentSnapshots = await group.get().toPromise();
            documentSnapshots.forEach(async docRef => {
                const x = docRef.data();
                (x as any).id = docRef.id;
                data.push(x);
            });
            return resolve(data);
        });
    }



    async getGroupOnce(id) {
        return new Promise(async (resolve, reject) => {
            const docRef = this.firestore.collection('groups').doc(id);
            const docSnap = await docRef.get().toPromise();
            if (docSnap.exists) {
                const group = { id: docSnap.id, ...((docSnap.data() as any) || {}) };
                return resolve(group);
            } else {
                return resolve(undefined);
            }
        });
    }

    async getGroup(id) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        if (this.unsub1) {
            this.clearGroup();
        }
        this.unsub1 = this.firestore.collection('groups').doc(id).snapshotChanges().subscribe(async (result) => {
            const data = result.payload.data() as any;
            this.group = { id: result.payload.id, isEditable: data?.admins?.includes(this.currentUser?.id), ...data };
            console.log(this.group);
            window.dispatchEvent(new Event('group-update'));
        });
    }

    clearGroup() {
        if (this.unsub1 && this.unsub1.unsubscribe) {
            this.unsub1.unsubscribe();
        }
        this.unsub1 = undefined;
        this.group = undefined;
    }

    async createOrUpdateGroup(id, data) {
        Object.keys(data).forEach(key => {
            if (data[key] === undefined || data[key] === null) {
                delete data[key];
            }
        });
        console.log(data);
        data.nameLower = data.name.toLowerCase();
        if (id) {
            return await this.firestore.collection('groups').doc(id).update(data);
        } else {
            return await this.firestore.collection('groups').add({
                ...data,
            });
        }
    }

    async getGroups(more) {
        const limitCount = 25;
        if (!more) {
            this.endReached = false;
            this.groups = [];
            const first = this.firestore.collection('groups', ref => ref.orderBy('recentlyActive').limit(limitCount));
            const documentSnapshots = await first.get().toPromise();
            documentSnapshots.forEach(async (docRef) => {
                const group: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
                if (!Array.isArray(group?.joined)) { group.joined = []; }
                await group.joined.forEach(async (id) => {
                    if (!Array.isArray(group?.joinedUserData)) { group.joinedUserData = []; }
                    group.joinedUserData.push(await this.authService.getUserById(id));
                });
                this.groups.push(group);
                console.log(this.groups);
            });
        } else {
            const lastVisible = this.groups[this.groups.length - 1];
            if (lastVisible && !this.endReached) {
                const next = this.firestore.collection('groups', ref => ref.orderBy('recentlyActive').startAfter(lastVisible).limit(25));
                const documentSnapshots = await next.get().toPromise();
                if (documentSnapshots.size < limitCount) { this.endReached = true; }
                documentSnapshots.forEach(async (docRef) => {
                    const group: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
                    if (!Array.isArray(group?.joined)) { group.joined = []; }
                    await group.joined.forEach(async (id) => {
                        if (!Array.isArray(group?.joinedUserData)) { group.joinedUserData = []; }
                        group.joinedUserData.push(await this.authService.getUserById(id));
                    });
                    this.groups.push(group);
                });
            }
        }
    }

    async getGroupsByQueryConstraints(more, queryConstraints) {
        const limitCount = 25;
        if (!more) {
            this.endReached = false;
            this.groups = [];
            const first = this.firestore.collection('groups', ref => ref.limit(limitCount));
            const documentSnapshots = await first.get().toPromise();
            documentSnapshots.forEach(async (docRef) => {
                const group: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
                if (!Array.isArray(group?.joined)) { group.joined = []; }
                await group.joined.forEach(async (id) => {
                    if (!Array.isArray(group?.joinedUserData)) { group.joinedUserData = []; }
                    group.joinedUserData.push(await this.authService.getUserById(id));
                });
                this.groups.push(group);
                console.log(this.groups);
            });
        } else {
            const lastVisible = this.groups[this.groups.length - 1];
            if (lastVisible && !this.endReached) {
                const next = this.firestore.collection('groups', ref => ref.orderBy('recentlyActive').startAfter(lastVisible).limit(25));
                const documentSnapshots = await next.get().toPromise();
                if (documentSnapshots.size < limitCount) { this.endReached = true; }
                documentSnapshots.forEach(async (docRef) => {
                    const group: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
                    if (!Array.isArray(group?.joined)) { group.joined = []; }
                    await group.joined.forEach(async (id) => {
                        if (!Array.isArray(group?.joinedUserData)) { group.joinedUserData = []; }
                        group.joinedUserData.push(await this.authService.getUserById(id));
                    });
                    this.groups.push(group);
                });
            }
        }
    }

    async like() {
        if (!this.group || !this.currentUser) {return;}
        if (!Array.isArray(this.group?.likes)) { this.group.likes = []; }
        const docRef = this.firestore.collection('groups').doc(this.group.id);
        if (this.group?.likes?.includes(this.currentUser.id)) {
            // this.group.likes.splice(this.group.likes.indexOf(this.currentUser.id), 1);
            // docRef.update({
            //     likes: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id)
            // });
        } else {
            this.group.likes.push(this.currentUser.id);
            docRef.update({
                likes: firebase.firestore.FieldValue.arrayUnion(this.currentUser.id)
            });
        }
    }

    async join() {
        if (!this.group || !this.currentUser) {return;}
        if (this.group?.type === 'public') {
            if (!Array.isArray(this.group?.joined)) { this.group.joined = []; }
            const docRef = this.firestore.collection('groups').doc(this.group.id);
            if (this.group?.joined?.includes(this.currentUser.id)) {
                this.group.joined.splice(this.group.joined.indexOf(this.currentUser.id), 1);
                docRef.update({
                    joined: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id),
                    joinRequests: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id)
                });
            } else {
                this.group.joined.push(this.currentUser.id);
                docRef.update({
                    joined: firebase.firestore.FieldValue.arrayUnion(this.currentUser.id),
                    joinRequests: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id)
                });
            }
        }
        if (this.group?.type === 'private') {
            this.joinRequests();
        }
    }

    async joinRequests() {
        if (!this.group || !this.currentUser) {return;}
        if (!Array.isArray(this.group?.joinRequests)) { this.group.joinRequests = []; }
        const docRef = this.firestore.collection('groups').doc(this.group.id);
        if (this.group?.joined?.includes(this.currentUser.id) || this.group?.joinRequests?.includes(this.currentUser.id)) {
            this.group.joined.splice(this.group.joined.indexOf(this.currentUser.id), 1);
            this.group.joinRequests.splice(this.group.joinRequests.indexOf(this.currentUser.id), 1);
            docRef.update({
                joined: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id),
                joinRequests: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id)
            });
        } else {
            if (this.group?.joined) {
                this.group.joined.splice(this.group.joined.indexOf(this.currentUser.id), 1);
            }
            this.group.joinRequests.push(this.currentUser.id);
            docRef.update({
                joined: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id),
                joinRequests: firebase.firestore.FieldValue.arrayUnion(this.currentUser.id)
            });
        }
    }

    async joinAccept(id) {
        if (!this.group) {return;}
        if (!Array.isArray(this.group?.joinRequests)) { this.group.joinRequests = []; }
        const docRef = this.firestore.collection('groups').doc(this.group.id);
        if (this.group?.joined?.includes(id)) {
            // Already joined
        } else {
            this.group.joined.push(id);
            this.group.joinRequests.splice(this.group.joinRequests.indexOf(id), 1);
            docRef.update({
                joined: firebase.firestore.FieldValue.arrayUnion(id),
                joinRequests: firebase.firestore.FieldValue.arrayRemove(id)
            });
        }
    }

    async joinReject(id) {
        if (!this.group) {return;}
        if (!Array.isArray(this.group?.joinRequests)) { this.group.joinRequests = []; }
        const docRef = this.firestore.collection('groups').doc(this.group.id);
        this.group.joined.splice(this.group.joined.indexOf(id), 1);
        this.group.joinRequests.splice(this.group.joinRequests.indexOf(id), 1);
        docRef.update({
            joined: firebase.firestore.FieldValue.arrayRemove(id),
            joinRequests: firebase.firestore.FieldValue.arrayRemove(id)
        });
    }

    async presentToast(message) {
        const toast = await this.toastController.create({
            message,
            duration: 3000,
            position: 'top',
        });
        toast.present();
    }
}
